const initMenuMobile = () => {
  const menuButton = document.querySelector('.nav__toggle');
  const menu = document.querySelector('#mobileMenu');

  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      menu.classList.toggle('open');
      menuButton.classList.toggle('open');
    });
  }

  const parentLinks = document.querySelectorAll('.mobile-menu__menu-list .parent-link');

  parentLinks.forEach(parentLink => {
    const hasChildren = parentLink.querySelector('ul');

    if (hasChildren) {
      const trigger = parentLink.querySelector('a, span');
      const childLinks = parentLink.querySelectorAll(':scope > ul > .child-link');

      trigger.addEventListener('click', (e) => {
        e.preventDefault();

        parentLink.classList.toggle('open');

        childLinks.forEach(childLink => {
          childLink.classList.toggle('open');
        });
      });
    }
  });
}

export { initMenuMobile };